import React, { ForwardedRef } from 'react';
import {
  styled,
  Text,
  TokenTextAppearance,
} from '@volkswagen-onehub/components-core';
import {InventoryType} from '../Filtering/common/InventoryType';
import FilterAccordion from './FilterAccordion';
import { Distance } from '../Filtering/common/Distance';
import { getTranslations } from '../translations';
import { DealerList } from '../Filtering/common/DealerList';
import { PriceSlider } from '../Filtering/common/PriceSlider';
import { YearSlider } from '../Filtering/common/YearSlider';
import { MileageSlider } from '../Filtering/common/MileageSlider';
import { TransmissionSelect } from '../Filtering/common/TransmissionSelect';
import { TrimSelect } from '../Filtering/common/TrimSelect';
import { ExteriorSelect } from '../Filtering/common/ExteriorSelect';
import { InteriorSelect } from '../Filtering/common/InteriorSelect';
import { InStockOption } from '../Filtering/common/InStockOption';
import { useSelectedFilterStore } from '../store/filtersv2';
import useFiltersCountQuery from '../api/use-filters-count-query';
import { FiltersResponse, FiltersResponseKey, MinMaxOption, ResponseSelector } from '../types';

const Container = styled.div`
  width: 100%;
  padding: 0 ${(props) => props.theme.size.dynamic0100}
    ${(props) => props.theme.size.dynamic0100};
  overflow: auto;
`;

type Props = {
  innerRef?: ForwardedRef<HTMLDivElement>;
}

const FilterMenuInner = ({ innerRef }:  Props) => {
  const { labels } = getTranslations();

  const { selected } = useSelectedFilterStore();
  const { category } = selected;

  const getMileageRange: ResponseSelector<FiltersResponse, MinMaxOption> = res => res[FiltersResponseKey.MILEAGE];
  const { data } = useFiltersCountQuery({select: getMileageRange});


  return (
    <Container ref={innerRef}>
      <Text id="filters_panel_header" appearance={TokenTextAppearance.headline400} bold>
        { labels.filters }
      </Text>
      <FilterAccordion label={labels.inventory_type}>
        <InventoryType />
        <InStockOption />
      </FilterAccordion>
      <FilterAccordion label={labels.location}>
        <Distance />
        <DealerList />
      </FilterAccordion>
      <FilterAccordion label={labels.price}>
        <PriceSlider />
      </FilterAccordion>
      {
        (category?.includes("used")
        || category?.includes("certified")
        || !category?.length)
        && (data as MinMaxOption)?.max > 0
        ? <FilterAccordion label={labels.mileage}>
          <MileageSlider />
        </FilterAccordion>
        : null
      }
      <FilterAccordion label={labels.year}>
        <YearSlider />
      </FilterAccordion>
      <FilterAccordion label={labels.transmission}>
        <TransmissionSelect />
      </FilterAccordion>
      <FilterAccordion label={labels.trim}>
        <TrimSelect />
      </FilterAccordion>
      <FilterAccordion label={labels.exterior}>
        <ExteriorSelect />
      </FilterAccordion>
      <FilterAccordion label={labels.interior}>
        <InteriorSelect />
      </FilterAccordion>
    </Container>
  );
};

export const FilterMenu = React.forwardRef<HTMLDivElement, Props>((props, ref) => <FilterMenuInner innerRef={ref} {...props} />);
